// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"654":"db28d377","882":"a4e9bc56"}[chunkId] + ".chunk.css";
};